export default __webpack_public_path__ + "static/media/fin-tracks.04b5f108.svg";